import styled from 'styled-components';

export const KeywordContainer = styled.div`
  display: flex;
`;

export const KeywordItemContainer = styled.div`
  background: var(--Pending_Background);
  border-radius: 4px;
  color: var(--Pending_Default);
  margin-right: 8px;
  margin-top: 12px;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0px;
  height: 24px;
  border-radius: 4px;
  padding: 0px 6px;
  cursor: pointer;
  display: block;
  :hover {
    color: var(--Pending_Default);
    background-color: var(--Pending_Disabled);
  }
`;

export const ExpanderContainer = styled.div`
  position: relative;
  top: 15px;
  width: 64px;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: right;
  cursor: pointer;
  color: var(--Fill_Brand_Primary);

  &:hover {
    color: var(--Fill_Brand_Primary);
    opacity: 0.9;
  }
  &:active {
    color: var(--Fill_Brand_Primary);
    opacity: 0.9;
  }
`;
